<template>
  <div>
    <input v-model="keyword" />
    <button @click="searchHandler">جستجو</button>
    <br />
    <span v-if="user">{{ user.destination_account_id }}</span>
    <br />
    <button @click="transactionHandler">پرداخت</button>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";

export default {
  setup() {
    const route = useRoute();
    let keyword = ref("");
    let user = ref(Object);

    function searchHandler() {
      const token = localStorage.getItem("token");
      axios
        .post(
          "https://gamma.bfst.ir/user/find/",
          {
            keyword: keyword.value,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((response) => {
          user.value = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    }

    function transactionHandler() {
      const token = localStorage.getItem("token");
      axios.post(
        "https://gamma.bfst.ir/transaction/",
        {
          source_account_id: "b1661d0a-45c4-48e2-bd5b-45bf0e7ac9fb",
          destinations: [
            {
              destination_id: user.value.destination_account_id,
              keyword: keyword.value,
            },
          ],
          description: "test",
          amount: route.params.amount,
          note: "test",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    }

    return {
      keyword,
      user,
      searchHandler,
      transactionHandler,
    };
  },
};
</script>
